import { Grid, Step, StepConnector, StepIconProps, StepLabel, Stepper } from '@mui/material';
import { makeStyles, withStyles } from '@mui/styles';
import clsx from 'clsx';
import styled from 'styled-components';

import { RoutalPalette } from '@nx-smartmonkey/ui';
import VehicleIcons from '../../assets/svg/VehicleIcons';

export const OnboardingContainer = styled(Grid)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: ${RoutalPalette.neutral00};
`;

export const OnboardingContent = styled(Grid)`
  height: 100%;
  width: 100%;
`;

export const OnboardingHeader = styled(Grid)`
  max-width: 380px;
`;

export const OnboardingBody = styled.div`
  padding: 32px 28px;
  width: 100%;
  background: ${RoutalPalette.neutral00};
  max-width: 380px;
  border-radius: 4px;
  align-self: center;
  margin-bottom: 20px !important;
`;

type OnboardingStepsProps = {
  activeStep: number;
  totalSteps: number;
  handleClick?: (...args: any[]) => any;
};

export const OnboardingSteps = ({ activeStep, totalSteps, handleClick }: OnboardingStepsProps) => {
  const StepperConnector = withStyles({
    alternativeLabel: {
      top: 10,
      left: `calc(-80% + 16px)`,
      right: `calc(20% + 16px)`,
    },
    active: {
      '& $line': {
        borderColor: `#474F61`,
      },
    },
    completed: {
      '& $line': {
        borderColor: `#474F61`,
      },
    },
    line: {
      borderColor: `#CECDCD`,
      borderTopWidth: 3,
      borderRadius: 1,
      padding: 0,
    },
  })(StepConnector);

  const useStepIconStyles = makeStyles({
    root: {
      color: `#CECDCD`,
      display: `flex`,
      height: 22,
      alignItems: `center`,
      zIndex: 1,
    },
    active: {
      color: `#474F61`,
    },
    circle: {
      width: 18,
      height: 18,
      borderRadius: `50%`,
      backgroundColor: `currentColor`,
      color: `#CECDCD`,
      display: `flex`,
      flexDirection: `row`,
      justifyContent: `center`,
      alignItems: `center`,
    },
    activeCircle: {
      width: 32,
      height: 32,
      borderRadius: `50%`,
      backgroundColor: `#474F61`,
      color: `white`,
      display: `flex`,
      flexDirection: `row`,
      justifyContent: `center`,
      alignItems: `center`,
    },
    initialCircle: {
      width: 8,
      height: 8,
      borderRadius: `50%`,
      backgroundColor: `#474F61`,
    },
    lastCircle: {
      width: 8,
      height: 8,
      borderRadius: `50%`,
      backgroundColor: `#CECDCD`,
    },
    completed: {
      backgroundColor: `#474F61`,
    },
  });

  function StepIcon(props: StepIconProps, index: number) {
    const classes = useStepIconStyles();
    const { active, completed } = props;

    return (
      <div
        onClick={() => {
          if (handleClick) handleClick(index);
        }}
        className={clsx(classes.root, {
          [classes.active]: active,
        })}
        style={{
          ...(handleClick && index < activeStep ? { cursor: `pointer` } : {}),
        }}
      >
        {completed ? (
          <div className={clsx(classes.circle, classes.completed)}>
            <span style={{ color: `white`, fontSize: `10px` }}>{index}</span>
          </div>
        ) : !active ? (
          <div className={classes.circle}>
            <span style={{ color: `white`, fontSize: `10px` }}>{index}</span>
          </div>
        ) : (
          <div className={classes.activeCircle}>
            {/* eslint-disable-next-line react/jsx-pascal-case */}
            <VehicleIcons.furgo />
          </div>
        )}
      </div>
    );
  }

  function InicialStepIcon() {
    const classes = useStepIconStyles();
    return (
      <div className={clsx(classes.root)}>
        <div className={classes.initialCircle} />
      </div>
    );
  }

  function LastStepIcon() {
    const classes = useStepIconStyles();
    return (
      <div className={clsx(classes.root)}>
        <div className={classes.lastCircle} />
      </div>
    );
  }

  return (
    <div style={{ width: `380px` }}>
      <Stepper alternativeLabel activeStep={activeStep} style={{ padding: 0 }} connector={<StepperConnector />}>
        {new Array(totalSteps).fill(null).map((step, index: number) => (
          <Step key={index}>
            {index === 0 || index === totalSteps - 1 ? (
              <StepLabel StepIconComponent={index === 0 ? InicialStepIcon : LastStepIcon} />
            ) : (
              <StepLabel StepIconComponent={(props: StepIconProps) => StepIcon(props, index)} />
            )}
          </Step>
        ))}
      </Stepper>
    </div>
  );
};
